/**
 * Created by robert.lavoie on 6/28/17.
 */

import { Component, Input, Output, EventEmitter } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

// Models
import { Filter } from '../../models';

// Services
import { ReportingService } from '../../services';

/**
 *
 * @class
 * JobSearchFiltersComponent
 *
 * @description
 * This component is used to display the filter options on large screen sizes
 *
 */
@Component({
  templateUrl: './job-search-filters.component.html',
  selector: 'job-search-filters',
  styleUrls: ['./job-search-filters.component.scss'],
  animations: [
    trigger('slideUpDown', [
      state('up', style({
        maxHeight: '0px'
      })),
      state('down', style({
        maxHeight: '300px'
      })),
      transition('up <=> down', animate('300ms ease-out'))
    ]),
  ]
})
export class JobSearchFiltersComponent {

  // An array of all the available filters
  @Input() availableFilters: Filter[];

  // The site theme color
  @Input() themeColor: string;

  // Emits and event to the host when a user hits the applyFilters button
  @Output() applyFilters: EventEmitter<any> = new EventEmitter();

  // Emits and event to the host when a user hits the resetFilters button
  @Output() resetFilter: EventEmitter<any> = new EventEmitter();

  constructor(
    private reportingService: ReportingService
  ) { }

  /**
   * Closes drop down and emits the applyFilters to the host
   *
   * @param { Filter }
   *
   */
  apply(filter: Filter){
    this.toggleFilterDropdownState(filter);
    this.applyFilters.emit();
    this.reportingService.trackCustomEvent(`cp_searchdrop_${filter.className}_apply`);
  }

  /**
   * Closes drop down and emits the resetFilter to the host
   *
   * @param { Filter }
   *
   */
  reset(filter: Filter){
    this.toggleFilterDropdownState(filter);
    this.resetFilter.emit(filter);
    this.reportingService.trackCustomEvent(`cp_searchdrop_${filter.className}_reset`);
  }


  /**
   * Toggles the state of the filter dropdown
   *
   * @param { Filter }
   *
   */
  toggleFilterDropdownState(filter: Filter){

    // Get every filter that is not the clicked filter, we use this to close any open filter dropdowns
    const otherFilters: Filter[] = this.availableFilters.filter(f => f !== filter);
    otherFilters.forEach((filter) => {
      filter.animatedState = 'up';
    });

    // Toggle the filters animatedState state to either up or down
    filter.animatedState = filter.animatedState === 'up' ? 'down' : 'up';

    // If the animatedState is down, then the filter just expanded and we fire an event
    if (filter.animatedState == 'down') {
      this.reportingService.trackCustomEvent(`cp_searchdrop_${filter.className}_open`);
    }

  }


  /**
   * Toggles the selected state of the filters
   *
   * @param { number }
   */
  onSelectionChange(filtersIndex: number, optionsIndex: number){

    // Reset all selected items to false if the filter type is a radio button
    if (this.availableFilters[filtersIndex]['type'] === 'radio'){
      this.availableFilters[filtersIndex]['options'].forEach((item) => {
        item['selected'] = false;
      });
    }

    this.availableFilters[filtersIndex]['options'][optionsIndex]['selected'] = this.availableFilters[filtersIndex]['options'][optionsIndex]['selected'] === true ? false : true;

  }

}
